/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_BankInputs */

const vi_payment_method_bank = /** @type {(inputs: Payment_Method_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển khoản`)
};

/**

* @param {Payment_Method_BankInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_bank = /** @type {((inputs?: Payment_Method_BankInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_BankInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_bank(inputs)
});